/*
 * Copyright 2025 ixPilot Teknoloji A.Ş. (ixpilot2021@gmail.com)
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, modification, or distribution of this software,
 * via any medium, is strictly prohibited.
 *
 * Developed and maintained by ixPilot Teknoloji A.Ş.
 */

import React from "react";
import { createRoot } from "react-dom/client";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";

import theme from "theme/theme.js";
import { UserProvider } from "contexts/UserContext";

// Layoutlar
import Login from "layouts/Login.js";       // 🔑 Auth (login) layout
import AdminLayout from "layouts/Admin.js"; // 🔒 Admin layout

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <ChakraProvider theme={theme} resetCss={false} position="relative">
    <HashRouter>
      <UserProvider>
        <Switch>
          {/* Auth layout */}
          <Route path="/login" component={Login} />   {/* ✅ Login layout artık /login altında */}

          {/* Admin layout (giriş zorunlu - AdminLayout içinde authentication kontrolü var) */}
          <Route path="/admin" component={AdminLayout} />

          {/* Default redirect */}
          <Redirect exact from="/" to="/login" />
        </Switch>
      </UserProvider>
    </HashRouter>
  </ChakraProvider>
);
